import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_2 = { class: "bg-white rounded-lg shadow-md overflow-hidden" }
const _hoisted_3 = { class: "p-6 flex flex-col items-center justify-center py-8" }
const _hoisted_4 = { class: "bg-white rounded-lg shadow-md overflow-hidden" }
const _hoisted_5 = { class: "p-6 flex flex-col items-center justify-center py-8" }
const _hoisted_6 = { class: "bg-white rounded-lg shadow-md overflow-hidden" }
const _hoisted_7 = { class: "p-6 flex flex-col items-center justify-center py-8" }
const _hoisted_8 = { class: "bg-white rounded-lg shadow-md overflow-hidden" }
const _hoisted_9 = { class: "p-6 flex flex-col items-center justify-center py-8" }
const _hoisted_10 = { class: "bg-white rounded-lg shadow-md overflow-hidden" }
const _hoisted_11 = { class: "p-6 flex flex-col items-center justify-center py-8" }
const _hoisted_12 = { class: "bg-white rounded-lg shadow-md overflow-hidden" }
const _hoisted_13 = { class: "p-6 flex flex-col items-center justify-center py-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg-primary/10 p-4 border-b border-primary/20" }, [
        _createElementVNode("h2", { class: "text-xl font-semibold text-primary" }, "Email Template Management"),
        _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, "Create and manage email templates for automated communications")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/administration/email-templates",
          class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary inline-block"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Manage Email Templates ")
          ])),
          _: 1,
          __: [0]
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg-blue-50 p-4 border-b border-blue-100" }, [
        _createElementVNode("h2", { class: "text-xl font-semibold text-blue-700" }, "User Role Management"),
        _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, "Assign and manage user roles and permissions")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-gray-500 mb-4 text-center" }, "This feature will be implemented in a future update.", -1)),
        _createVNode(_component_router_link, {
          to: "/administration/user-roles",
          class: "px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 inline-block"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Manage User Roles ")
          ])),
          _: 1,
          __: [2]
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "bg-amber-50 p-4 border-b border-amber-100" }, [
        _createElementVNode("h2", { class: "text-xl font-semibold text-amber-700" }, "Due Date Management"),
        _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, "Configure due dates for different actions and document types")
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/administration/due-dates",
          class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-amber-600 hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 inline-block"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode(" Manage Due Dates ")
          ])),
          _: 1,
          __: [5]
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "bg-green-50 p-4 border-b border-green-100" }, [
        _createElementVNode("h2", { class: "text-xl font-semibold text-green-700" }, "System Configuration"),
        _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, "Configure system-wide settings and parameters")
      ], -1)),
      _createElementVNode("div", _hoisted_9, [
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-gray-500 mb-4 text-center" }, "This feature will be implemented in a future update.", -1)),
        _createVNode(_component_router_link, {
          to: "/administration/system-config",
          class: "px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-100 bg-green-700 hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 inline-block"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode(" Configure System ")
          ])),
          _: 1,
          __: [7]
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "bg-purple-50 p-4 border-b border-purple-100" }, [
        _createElementVNode("h2", { class: "text-xl font-semibold text-purple-700" }, "Audit Logs"),
        _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, "View system activity and user action logs")
      ], -1)),
      _createElementVNode("div", _hoisted_11, [
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-gray-500 mb-4 text-center" }, "This feature will be implemented in a future update.", -1)),
        _createVNode(_component_router_link, {
          to: "/administration/audit-logs",
          class: "px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 inline-block"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode(" View Audit Logs ")
          ])),
          _: 1,
          __: [10]
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "bg-indigo-50 p-4 border-b border-indigo-100" }, [
        _createElementVNode("h2", { class: "text-xl font-semibold text-indigo-700" }, "Knowledgebase Advisori"),
        _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, "Manage the knowledge database for Advisori")
      ], -1)),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          to: "/administration/manage-knowledgebase",
          class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 inline-block"
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode(" Manage Knowledgebase ")
          ])),
          _: 1,
          __: [13]
        })
      ])
    ])
  ]))
}